import {PAGE_URL, PERMISSION_KEY} from "../services/constant";

const nebulaUltraTransactionsMenuRegistry = {
    personalize_nebulaUltraTransactions: {
        label: "Nebula Ultra Transactions",
        link: PAGE_URL.NEBULA_ULTRA_TRANSACTIONS_PAGE,
        key: PAGE_URL.NEBULA_ULTRA_TRANSACTIONS_PAGE,
        resourceKey: PERMISSION_KEY
    }
};
export default nebulaUltraTransactionsMenuRegistry;
